import { Avatar } from '@mui/material';
import SituacaoImpedimentosProcessoBusiness from '../../dominio/SituacaoImpedimentosProcessoBusiness';
import { makeObservable, observable } from 'mobx';
import ErrorUtil from '../../util/ErrorUtil';
import SituacaoImpedimentosProcesso, {
    SITUACAO_IMPEDIMENTOS_PROCESSO
} from '../../dominio/SituacaoImpedimentosProcesso';
import { Filtro, TIPO_CONJUNTO_OPCOES_FILTRO } from './Filtro';

export default class FiltroSituacaoImpedimentosProcesso extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    get label() {
        return 'Situação de impedimentos';
    }

    getIconeFiltroRapido() {
        const qtdRegistros = this.filtroRapido.qtdRegistros ?? 0;
        const qtdRegistrosFiltrados = this.filtroRapido.qtdRegistrosFiltrados ?? 0;

        const backgroundColor = qtdRegistros > 0 || qtdRegistrosFiltrados > 0 ? 'black' : 'rgba(0, 0, 0, 0.3)';

        return (
            <Avatar
                variant="rounded"
                style={{
                    width: '24px',
                    height: '24px',
                    fontWeight: '600',
                    fontSize: '0.98rem',
                    backgroundColor
                }}
            >
                I
            </Avatar>
        );
    }

    opcoesFiltro = FiltroSituacaoImpedimentosProcesso.#carregarOpcoes();

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    filtroRapido = {
        opcoes: this.getOpcoesFiltro('valor', 'cor')
    };

    static #carregarOpcoes() {
        return [
            {
                valor: SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_NA_COMPOSICAO.id,
                cor: SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_NA_COMPOSICAO.cor,
                icone: SituacaoImpedimentosProcesso.getIcone(
                    SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_NA_COMPOSICAO.id
                )
            },
            {
                valor: SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_NA_COMPOSICAO.id,
                cor: SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_NA_COMPOSICAO.cor,
                icone: SituacaoImpedimentosProcesso.getIcone(
                    SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_NA_COMPOSICAO.id
                )
            },
            {
                valor: SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_FORA_DA_COMPOSICAO.id,
                cor: SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_FORA_DA_COMPOSICAO.cor,
                icone: SituacaoImpedimentosProcesso.getIcone(
                    SITUACAO_IMPEDIMENTOS_PROCESSO.IMPEDIMENTO_DECLARADO_FORA_DA_COMPOSICAO.id
                )
            },
            {
                valor: SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_FORA_DA_COMPOSICAO.id,
                cor: SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_FORA_DA_COMPOSICAO.cor,
                icone: SituacaoImpedimentosProcesso.getIcone(
                    SITUACAO_IMPEDIMENTOS_PROCESSO.POSSIVEL_IMPEDIMENTO_FORA_DA_COMPOSICAO.id
                )
            }
        ];
    }

    get tipoConjuntoOpcoes() {
        return TIPO_CONJUNTO_OPCOES_FILTRO.COM_INTERSECAO;
    }

    getValorOpcao(registro) {
        let situacoesCorrespondentes = [];

        try {
            const situacaoBusiness = new SituacaoImpedimentosProcessoBusiness(registro);
            situacoesCorrespondentes = situacaoBusiness.getSituacoes();
        } catch (e) {
            console.error(ErrorUtil.montarMensagemErro(e));
        }

        return situacoesCorrespondentes;
    }

    getDescricao(valor) {
        return SituacaoImpedimentosProcesso.getDescricao(valor);
    }
}
